import React from 'react';

const ScheduleSessionModal = ({
  show,
  handleClose,
  handleConfirm,
  schedulingSession,
  scheduleSessionMutation,
}) => {
  if (!show || !schedulingSession) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-600 bg-opacity-75 p-2 md:p-4"
      onClick={handleClose}
    >
      <div
        className="max-h-[95vh] w-full max-w-2xl overflow-y-auto rounded-lg bg-white md:max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-gray-200 px-4 py-4 md:px-6">
          <h3 className="text-lg font-medium text-gray-900">
            Schedule Session: {schedulingSession.title}
          </h3>
        </div>

        <div className="p-4 md:p-6">
          <p className="mb-4 text-gray-600">
            This will convert the unscheduled session to a scheduled session with specific times. It
            is recommended to use the{' '}
            <a className="text-blue-600 underline" href="/planner">
              planner
            </a>{' '}
            to schedule sessions, but this allows you to set a time for the session.
          </p>

          <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <label className="form-label">Default Start Time</label>
              <input
                type="time"
                className="form-input"
                defaultValue="09:00"
                id="schedule-start-time"
              />
            </div>
            <div>
              <label className="form-label">Default End Time</label>
              <input
                type="time"
                className="form-input"
                defaultValue="11:00"
                id="schedule-end-time"
              />
            </div>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:justify-end sm:gap-0 sm:space-x-3">
            <button type="button" onClick={handleClose} className="btn-secondary w-full sm:w-auto">
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={scheduleSessionMutation.isLoading}
              className="btn-primary w-full sm:w-auto"
            >
              {scheduleSessionMutation.isLoading ? 'Scheduling...' : 'Schedule Session'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleSessionModal;
